import React, { useState } from 'react';
import './AboutSection.css';

const AboutSection = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);

  const edgePoints = [
    { title: 'Lightning Delivery', desc: 'Fast, reliable shipping to keep your stock flowing.' },
    { title: 'Unbeatable Prices', desc: 'Wholesale deals that maximize your margins.' },
    { title: 'Diverse Stock', desc: 'From snacks to soaps, we’ve got it all.' },
    { title: 'Trader Support', desc: 'Personalized service for your business needs.' },
  ];

  const bulkWins = [
    { label: 'Units Moved', value: 1200, suffix: '+' },
    { label: 'Clients Served', value: 500, suffix: '+' },
    { label: 'Deals Secured', value: 150, suffix: '+' },
    { label: 'Regions Covered', value: 4, suffix: '+' },
  ];

  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <h2 className="about-title">Why Nand Cash and Carry?</h2>
        <div className="about-content">
          <p>
            Established in 2025, Nand Cash and Carry LTD is your trusted wholesale partner based in Welling, UK. We empower businesses with bulk essentials—rice, beverages, cleaning supplies, and more—at prices designed to boost your profits. Led by Darshan C Patel, our mission is to deliver value, reliability, and exceptional service.
          </p>
        </div>
        <div
          className={`owner-contact ${isContactOpen ? 'open' : ''}`}
          onClick={() => setIsContactOpen(!isContactOpen)}
        >
          <span className="contact-toggle">Meet Darshan C Patel</span>
          <div className="contact-details">
            <p><strong>Darshan C Patel</strong></p>
            <p><a href="mailto:nandcashandcarry@gmail.com">nandcashandcarry@gmail.com</a></p>
            <p><a href="tel:+447506003713">07506003713</a></p>
            <p>77A Bellegrove Road, Welling, DA16 3PG</p>
          </div>
        </div>
        <div className="edge-points">
          {edgePoints.map((point, index) => (
            <div key={index} className="edge-point">
              <h4 className="edge-title">{point.title}</h4>
              <p className="edge-desc">{point.desc}</p>
            </div>
          ))}
        </div>
        {/* <div className="bulk-wins">
          {bulkWins.map((win, index) => (
            <div key={index} className="win-item">
              <span className="win-value">{win.value}{win.suffix}</span>
              <span className="win-label">{win.label}</span>
            </div>
          ))}
        </div> */}
        <a href="#products" className="about-cta">Explore Our Range</a>
      </div>
    </section>
  );
};

export default AboutSection;